import { filterTag_template } from "../../../../../../js/components/templates/filterTag_template";
import { DragAndDropHandler } from "../../../../../../js/utils/DragAndDropHandler";
import { vnTemplate } from "../../../../valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class imagePickerEdit_template extends vnTemplate {

    protected parent: any;

    public filterTag: filterTag_template;

    protected getTemplateHtml(): string {

        return /* html */`
            <div class="w-img-picker-form w-form" data-bind="css: { 'is-visible': isShown }">

                <div class="img-picker-form">
                    <div class="form-header">
                        <div class="section-title">
                            <h3 class="section-title">Edit image</h3>
                        </div>
                        <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
                    </div>
                    <!-- ko if: claidApiErrorMessage() -->
                    <div class="form-group">
                        <p class="form-text optimizer-error-notification" data-bind="text: claidApiErrorMessage"></p>
                    </div>
                    <!-- /ko -->
                    <div class="form-body videos_edit" style="max-height:100%;">

                        <div class="form-group">
                            <div class="form-img-container" data-bind="css: {'is-optimized' : isMobileOptimized()}">
                                <div class="w-img-optimization">
                                    <span class="icon i-mobile">Mobile Optimization Preview</span>
                                    <div class="img-optimization-overlay"></div>
                                    <div class="img-optimization-crop"></div>
                                    <div class="img-optimization-overlay"></div>
                                </div>
                                <img data-bind="attr: {src: fileUrl, alt: altText }">
                            </div>
                        </div>
                        <div class="form-group">
                            <dl class="double-list">
                                <dt><span>ratio</span></dt>
                                <dd><span data-bind="text: ratio"></span></dd>
                                <dt><span>mime</span></dt>
                                <dd><span data-bind="text: mimeType"></span></dd>
                                <dt><span>dimension</span></dt>
                                <dd><span class="lower-case" data-bind="text: width()+ 'px' + ' x ' + height() + 'px'"></span></dd>
                                <dt><span>file size</span></dt>
                                <dd><span data-bind="text: fileSize"></span></dd>
                                <dt><span>Enhanced</span></dt>
                                <dd><span data-bind="text: isAiTouched()"></span></dd>
                            </dl>
                        </div>
                        <div class="form-group">
                            <label class="form-label" for="">title</label>
                            <input class="input-text" type="text" data-bind="value: name">
                            <small data-bind="style: { color: nameError ? 'red' : 'white'}, text: nameErrorMsg, visible: nameError" class="form-error"></small>
                        </div>
                         <div class="form-group">
                            <label class="form-label" for="">alt text</label>
                            <input class="input-text" type="text" data-bind="value: altText">
                            <small data-bind="style: { color: altError ? 'red' : 'white'}, text: altErrorMsg, visible: altError" class="form-error"></small>
                        </div>

                        <div style="display: flex;">
                            <div class="form-group form-check-inline" data-bind="if: permissions()['article_edit_embargo'].write">
                                <input type="checkbox" data-bind=" checked: isUnderEmbargo" id="imagePicker-under-embargo">
                                <label for="imagePicker-under-embargo" class="form-label icon i-check">Under Embargo</label>
                            </div>
                            <div class="form-group form-check-inline" data-bind="css: {'is-disable' : idImage() }">
                                <input type="checkbox" data-bind=" checked: isWaterMark" id="imagePicker-watermark">
                                <label for="imagePicker-watermark" class="form-label icon i-check">WaterMark</label>
                            </div>
                        </div>

                        <div class="form-group" style="align-items: flex-start;">
                            <label class="form-label" for="">Credit Text</label>
                            <input class="input-text" type="text" id="image_caption">
                        </div>
                        <div class="form-group" style="align-items: flex-start;">
                            <label class="form-label" for="">description</label>
                            <textarea rows="4" id="image_description"></textarea>
                        </div>

                        <div class="form-group" style="align-items: flex-start;">
                            <label class="form-label" style="width: auto;">Tags</label>
                            ${this.filterTag.getHtmlBuild()}
                        </div>
                        <div class="form-group" data-bind="foreach: selectedTags, childrenComplete : handleDragAndDrop($element, selectedTags ,'.tag-element')">
                            <div class="btn-selection tag-element">
                                <div class="drag-handle i-move short"><button type="button" class="btn no-bg icon i-drag"></button></div>
                                <input type="radio"
                                    name="imageTag"
                                    data-bind="
                                        attr: {
                                            value: $data.tag.id,
                                            id: 'imageTag_' + $data.tag.id,
                                            checked: $parent.idPrimaryTag()? $parent.idPrimaryTag() === $data.tag.id : false
                                        },
                                        event: {
                                            click: $parent.onClickSetSelectedPrimaryTag
                                        }
                                    "
                                >
                                <label class="form-label" data-bind="text: $data.tag.name + ' ' + $data.tag.formattedTagTypeAndDataset, attr: { for: 'imageTag_' + $data.tag.id }"></label>
                                <button class="icon i-x-after" type="button" data-bind="visible: true, event: { click: $parent.onClickDeleteSelectedTag }"></button>
                            </div>
                        </div>

                    </div>

                     <div class="form-footer">
                        <button type="button" class="btn icon i-cancel" data-bind="event: { click: onClickCancel }">Cancel</button>

                        <div class="insert-dropdown" data-bind="visible: $parent.mode() != 'content-select'">
                            <button class="btn-icon insert-dropdown-toggle i-dropdown-simple icon i-ins" type="button"><span>Insert Selected <br>and Save</span></button>
                            <div class="insert-dropdown-list" data-bind="event: {mouseleave: onMouseLeave($data, false)}">
                                <!-- ko if: isImageOptimizable() && isLandscape() && !isWaterMark() -->
                                <button class="btn-icon icon i-mobile" data-bind="event: { click: onClickInsert.bind($data, '', true), mouseover: onMouseOver.bind($data, true) }" title="Insert Mobile Optimized On" type="button">
                                    <span>Insert Mobile Optimized On</span>
                                </button>
                                <button class="btn-icon icon i-ins-ind" data-bind="event: { click: onClickInsert.bind($data, '', false), mouseover: onMouseOver.bind($data, false) }" title="Insert Mobile Optimized Off" type="button">
                                    <span>Insert Mobile Optimized Off</span>
                                </button>
                                <!-- /ko -->
                                <!-- ko ifnot: isImageOptimizable() && isLandscape() && !isWaterMark()  -->
                                <button class="btn-icon icon i-ins-ind" data-bind="event: { click: onClickInsert.bind($data, '', false) }" title="Insert Individually" type="button"><span>Insert Individually</span></button>
                                <!-- /ko -->
                                <button class="btn-icon icon i-ins-gallery is-disable" title="Insert as Gallery" type="button"><span>Insert as Gallery</span></button>
                                <button class="btn-icon icon i-ins-grid" data-bind="event: { click: onClickInsert.bind($data, 'grid_view', false) }, visible: $parent.mode() == 'multi-select'" title="Insert as Grid" type="button"><span>Insert as Grid</span></button>
                            </div>
                        </div>

                        <button type="button" class="btn highlight icon i-save" data-bind="event: { click: onClickSave }">Save</button>

                        <button class="btn icon highlight" data-bind="visible: $parent.mode() == 'content-select', event: { click: onClickCancel }" type="button" title="Replace">Replace</button>
                        <div class="insert-dropdown" data-bind="visible: (isImageOptimizable() && isLandscape() && !isWaterMark() && $parent.mode() == 'content-select')">
                            <button class="btn-icon insert-dropdown-toggle i-dropdown-simple icon i-ins" type="button"><span>Insert Selected</span></button>
                            <div class="insert-dropdown-list">
                                <button class="btn-icon icon i-mobile" data-bind="visible: !isMobileOptimized(), event: { click: onClickInsert.bind($data, '', true) }" type="button" title="Reinsert Mobile Optimized On"><span>Reinsert Mobile Optimized On</span></button>
                                <button class="btn-icon icon i-mobile" data-bind="visible: isMobileOptimized(), event: { click: onClickInsert.bind($data, '', false) }" type="button" title="Reinsert Mobile Optimized Off"><span>Reinsert Mobile Optimized Off</span></button>
                                <button class="btn-icon icon i-ins-ind" data-bind="event: { click: onClickInsert.bind($data, '', false) }" title="Insert Individually" type="button"><span>Insert Individually</span></button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            `;
    }

    private onLoadTemplate () {

    }

    public getViewModelForRequest(){

        return {
            filters      : {
                keywords: this.getTemplateViewModel().filterSimple.filterKeyword,
            },
        }
    }

    public updateSelectedTags() {
        let idTagSelected = this.filterTag.getTemplateViewModel().idTag();
        let tagSelected = this.filterTag.getTemplateViewModel().tagObj();
        let selectedTags = this.getTemplateViewModel().selectedTags();

        if (idTagSelected != null) {
            //add to selected tags if its not already selected
            let alreadySelected = selectedTags.find((t) => t.tag.id == idTagSelected);

            if (!alreadySelected) {
                if (tagSelected.tagType != null) {
                    tagSelected.type = {};
                    tagSelected.type.id = tagSelected.idType;
                    tagSelected.type.name = tagSelected.tagType;
                }
                selectedTags.push({ id: null, tag: tagSelected });
            }
        }

        this.getTemplateViewModel().selectedTags([]);
        this.getTemplateViewModel().selectedTags(selectedTags);
        this.filterTag.clearInput();
    }

    protected setTagFilterAutocomplete(tags) {
        this.filterTag.getTemplateViewModel().tags(tags);
    }

    public handleDragAndDrop(element, currentObservableArray, childrenSelector): any {
        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray, childrenSelector);
    }

    public setSelectedTags(selectedTags): void {
        selectedTags.forEach((t) => {
            let formattedTagTypeAndDataset = "";
            if (t.tag.type != null) {
                formattedTagTypeAndDataset = " (" + t.tag.type.name + ")";
            }

            if (!t.tag["formattedTagTypeAndDataset"]) {
                t.tag["formattedTagTypeAndDataset"] = formattedTagTypeAndDataset;
            }
        });
        this.getTemplateViewModel().selectedTags(selectedTags);
    }

    protected onClickDeleteSelectedTag(data) {
        let idPrimaryTag = this.getTemplateViewModel().idPrimaryTag();
        let selectedTags = this.getTemplateViewModel().selectedTags();
        let index = selectedTags.findIndex((i) => i.tag.id == data.tag.id);
        if (index != -1) {
            selectedTags.splice(index, 1);
        }

        if (idPrimaryTag == data.tag.id) {
            this.getTemplateViewModel().idPrimaryTag(null);
        }

        this.getTemplateViewModel().selectedTags(selectedTags);
    }

    protected setSelectedPrimaryTag(data) {
        this.getTemplateViewModel().idPrimaryTag(data.tag.id);
    }

    protected initPartial(): void {
        this.filterTag = new filterTag_template("filterTagImagePickerEdit", this.getTemplateViewModel(), this.parent);
    }

    protected getTemplateName(): string {
        return "imagePickerEdit-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {

        //create observable array refresh function
        ko.observableArray.fn.refresh = function (item, index) {
            if (index==null) index = this['indexOf'](item);
            if (index >= 0) {
                this.splice(index, 1, ko.utils.extend({}, item)) // create new item
            }
        }

        // define the viewmodel data/ functions
        let self = this;
        return {
            isShown: ko.observable(false),
            name: ko.observable(null),
            idImage: ko.observable(null),
            caption: ko.observable(null),
            description: ko.observable(null),
            altText: ko.observable(null),
            dateCreated: ko.observable(null),
            width: ko.observable(null),
            height: ko.observable(null),
            selectedImage: ko.observable(null),
            fileSize: ko.observable(null),
            ratio: ko.observable(null),
            mimeType: ko.observable(null),
            fileUrl: ko.observable(null),
            nameError: ko.observable(false),
            nameErrorMsg: ko.observable("Title is required"),
            altError: ko.observable(false),
            altErrorMsg: ko.observable("Alternate text is required"),
            isUnderEmbargo: ko.observable(false),
            isWaterMark: ko.observable(false),
            isMobileOptimized: ko.observable(false),
            isMobileOptimizedOriginal: ko.observable(false),
            isLandscape: ko.observable(false),
            isPortrait: ko.observable(false),
            isSquare: ko.observable(false),
            isImageOptimizable:  ko.observable(false),
            permissions: ko.observableArray(this.initPermissions(['article_edit_embargo'])),
            mode: ko.observable(""),
            isAiEnhanced: ko.observable(true),
            isHdrAdjusted: ko.observable(true),
            selectedTags: ko.observableArray([]),
            idPrimaryTag: ko.observable(null),
            claidApiErrorMessage: ko.observable(null),
            onClickCancel: function(data, event){ self.onClickCancel();},
            onLoadTemplate: function(data, event){ self.onLoadTemplate();},
            onClickInsert: function(param,isOptimized, data, event){ self.onClickInsert(param, isOptimized, data);},
            onClickSave: function(data, event){ self.onClickSave();},
            onMouseOver: function(data, isOptimized){ self.onMouseOver(data, isOptimized, event);},
            onMouseLeave: function(data, isOptimized){ self.onMouseLeave(data, isOptimized, event);},
            handleDragAndDrop: function (element, currentObservableArray, childrenSelector) {
                self.handleDragAndDrop(element, currentObservableArray, childrenSelector);
            },
            onClickDeleteSelectedTag: function (data, event) {
                self.onClickDeleteSelectedTag(data);
            },
            onClickSetSelectedPrimaryTag: function (data, event) {
                self.setSelectedPrimaryTag(data);
                return true;
            },
            isAiTouched: function () {
                let anyIsOn = false;
                let whichIsOn = [];
                if (this.isAiEnhanced()) {
                    whichIsOn.push('Upscaled');
                    anyIsOn = true;
                }

                if (this.isHdrAdjusted()) {
                    whichIsOn.push('HDR Color Adjusted');
                    anyIsOn = true;
                }

                if (!anyIsOn) {
                    return "No";
                } else {
                    return `Yes (${whichIsOn.join(', ')})`;
                }
            },
        };
    }

    public setParent(parent){

        this.parent = parent;
        this.filterTag = new filterTag_template("filterTagImagePickerEdit", this.getTemplateViewModel(), this.parent);
    }

    protected onClickCancel(){
        this.getTemplateViewModel().nameError(false);
        this.getTemplateViewModel().altError(false);

        /*if(this.parent.getMode() == "content-select"){

            this.parent.hide()
        }*/
        this.hide();
    }

    public setIsImageOptimizable(isImageOptimizable: boolean): void {
        this.getTemplateViewModel().isImageOptimizable(isImageOptimizable);
    }

    public isImageOptimizable(): boolean {
        return this.getTemplateViewModel().isImageOptimizable();
    }

    public setIsLandscape(isLandscape: boolean): void {
        this.getTemplateViewModel().isLandscape(isLandscape);
    }

    public isLandscape(): boolean {
        return this.getTemplateViewModel().isLandscape();
    }

    public setIsPortrait(isPortrait: boolean): void {
        this.getTemplateViewModel().isPortrait(isPortrait);
    }

    public isPortrait(): boolean {
        return this.getTemplateViewModel().isPortrait();
    }

    public setIsSquare(isSquare: boolean): void {
        this.getTemplateViewModel().isSquare(isSquare);
    }

    public isSquare(): boolean {
        return this.getTemplateViewModel().isSquare();
    }

    protected onClickSave(){
        if(this.isFormValid()){

            let widget = null;
            if (this.parent && this.parent.caller && typeof this.parent.caller.getWidgetTemplate === 'function') {
                widget = this.parent.caller.getWidgetTemplate();
            }

            if(this.parent.getMode() == "content-select"){

                this.saveImage(true, '', widget);
                this.parent.hide()
            }else{

                this.saveImage(false, '', widget);
            }
            this.hide();
        }
    }

    protected onMouseOver(optimize, data, evt): void {

        this.getTemplateViewModel().isMobileOptimized(optimize);
    }

    protected onMouseLeave(data, optimize, evt): void {

        let isMobileOptimizedOriginal = this.getTemplateViewModel().isMobileOptimizedOriginal();
        this.getTemplateViewModel().isMobileOptimized(isMobileOptimizedOriginal);
    }



    protected getImage(){

        let viewModel = this.getTemplateViewModel();

        let isImageOptimizable = this.parent.isImageOptimizable();

        let image = { id: viewModel.idImage(),
            url: viewModel.fileUrl() ,
            name: viewModel.name(),
            caption: this.caller.getImageCaption(),
            description: this.caller.getImageDescription(),
            altText: viewModel.altText(),
            width: viewModel.width(),
            height: viewModel.height(),
            fileSize: viewModel.fileSize(),
            isUnderEmbargo: viewModel.isUnderEmbargo(),
            isWaterMark: viewModel.isWaterMark(),
            isMobileOptimized: viewModel.isMobileOptimized(),
            isLandscape: viewModel.isLandscape(),
            isPortrait: viewModel.isPortrait(),
            isSquare: viewModel.isSquare(),
            permissions: ko.observableArray(this.initPermissions(['article_edit_embargo'])),
            mimeType: viewModel.mimeType(),
            isAiEnhanced: viewModel.isAiEnhanced(),
            isHdrAdjusted: viewModel.isHdrAdjusted(),
            imageTagIds: viewModel.selectedTags().map(({ tag }) => tag.id),
            idPrimaryTag: viewModel.idPrimaryTag(),
        };

        return image;
    }

    private saveImage(insert, param, widget){
        this.parent.saveImages([this.getImage()], insert, param, 'image', widget);
    }

    protected isFormValid() {
        let valid = true;
        const viewModel = this.getTemplateViewModel();

        viewModel.nameError(false);
        viewModel.altError(false);

        let name = viewModel.name();
        let altText = viewModel.altText();

        if(name == "" || name == null || (name && name.trim() == "")){
            viewModel.nameError(true);
            valid = false;
        }

        if(altText == "" || altText == null || (altText && altText.trim() == "")){
            viewModel.altError(true);
            valid = false;
        }

        return valid;
    }

    protected onClickInsert(param, isOptimized, data){

        this.getTemplateViewModel().isMobileOptimized(isOptimized);



        let widget = null;
        if (this.parent && this.parent.caller && typeof this.parent.caller.getWidgetTemplate === 'function') {
            widget = this.parent.caller.getWidgetTemplate();
        }


        if(this.isFormValid()){
            this.saveImage(true, param, widget);
            this.hide();
        }

    }

    public setImage(image): void{

        if(image){
            const idPrimaryTag = image.details? image.details.idPrimaryTag
                : ( image.primaryTag ? image.primaryTag.id : null );

            this.getTemplateViewModel().idImage(image.id);
            this.getTemplateViewModel().name(image.name);
            this.getTemplateViewModel().caption(image.caption);
            this.getTemplateViewModel().description(image.description);
            this.getTemplateViewModel().altText(image.altText);
            this.getTemplateViewModel().dateCreated(image.dateCreated);
            this.getTemplateViewModel().width(image.width);
            this.getTemplateViewModel().height(image.height);
            this.getTemplateViewModel().fileSize(image.fileSize);
            this.getTemplateViewModel().ratio(image.ratio);
            this.getTemplateViewModel().mimeType(image.mimeType);
            this.getTemplateViewModel().isUnderEmbargo(image.isUnderEmbargo);
            this.getTemplateViewModel().isWaterMark(image.isWaterMark);
            this.getTemplateViewModel().isMobileOptimized(image.isMobileOptimized);
            this.getTemplateViewModel().isMobileOptimizedOriginal(image.isMobileOptimized);
            this.getTemplateViewModel().isLandscape(image.isLandscape);
            this.getTemplateViewModel().isPortrait(image.isPortrait);
            this.getTemplateViewModel().isSquare(image.isSquare);
            this.getTemplateViewModel().idPrimaryTag(idPrimaryTag);
            this.getTemplateViewModel().selectedTags(image.imageTags? image.imageTags : []);

            this.getTemplateViewModel().fileUrl(image.url.split("?")[0]);
            this.getTemplateViewModel().isAiEnhanced(image.isAiEnhanced);
            this.getTemplateViewModel().isHdrAdjusted(image.isHdrAdjusted);

            this.caller.setImageDescription(image.description);
            this.caller.setImageCaption(image.caption);
            let claidApiErrorMessage = sessionStorage.getItem("claidApiErrorMessage");
            if (claidApiErrorMessage) {
                this.setClaidApiErrorMessage(claidApiErrorMessage);
            }
            sessionStorage.removeItem("claidApiErrorMessage");

        }else{
            this.resetEditImageState()
        }

    }

    public show(){

        this.getTemplateViewModel().isShown(true);
    }

    public hide(){

        this.getTemplateViewModel().isShown(false);
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions)
    }

    public setMode(mode){
        this.getTemplateViewModel().mode(mode);
    }

    public resetEditImageState(){
        this.getTemplateViewModel().idImage(null);
        this.getTemplateViewModel().name(null);
        this.getTemplateViewModel().caption(null);
        this.getTemplateViewModel().description(null);
        this.getTemplateViewModel().altText(null);
        this.getTemplateViewModel().dateCreated(null);
        this.getTemplateViewModel().width(null);
        this.getTemplateViewModel().height(null);
        this.getTemplateViewModel().fileSize(null);
        this.getTemplateViewModel().ratio(null);
        this.getTemplateViewModel().mimeType(null);
        this.getTemplateViewModel().isUnderEmbargo(null);
        this.getTemplateViewModel().isWaterMark(null);
        this.getTemplateViewModel().isMobileOptimized(null);
        this.getTemplateViewModel().fileUrl(null);
        this.getTemplateViewModel().isLandscape(false);
        this.getTemplateViewModel().isAiEnhanced(true);
        this.getTemplateViewModel().isHdrAdjusted(true);
        this.getTemplateViewModel().claidApiErrorMessage(null);
    }

    public setClaidApiErrorMessage(message){
        this.getTemplateViewModel().claidApiErrorMessage(message)
    }

}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_imagePicker/js/components/templates/imagePickerEdit_template.ts